var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-icon",class:{'vertical': _vm.vertical}},[_c('i',{staticClass:"icon",class:( _obj = {}, _obj[_vm.icon] = true, _obj[_vm.iconState] = !!_vm.iconState, _obj )}),_c('div',{staticClass:"message"},[_vm._t("message",function(){return [(_vm.messageKey)?[_vm._v(" "+_vm._s(_vm.t(_vm.messageKey))+" ")]:[_vm._v(" "+_vm._s(_vm.message)+" ")]]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }